import { memo } from "react";
import { useTransactionContext } from "../../TransactionProvider";
import CodeSnippet from "ui/molecules/CodeSnippet";

const Request = () => {
    const transaction = useTransactionContext();

    return (
        <CodeSnippet
            data={transaction.transactionRequest}
        />
    );
};

export default memo(Request);
